export default __webpack_public_path__ + "media/images/mail/native-0685d48ee786b0d2e40545971c0730ba.png";